import { render, staticRenderFns } from "./CentralCosto.vue?vue&type=template&id=23231d04"
import script from "./CentralCosto.vue?vue&type=script&lang=js"
export * from "./CentralCosto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports